import { createPaginatedSlice } from "../../../helpers/reduxHelper";

const paginatedMaterials = createPaginatedSlice('paginatedMaterials');

export const paginatedMaterialsActions = paginatedMaterials.actions
export const paginatedMaterialsSelector = state => state.paginatedMaterials;
export const paginatedMaterialsReducer = paginatedMaterials.reducer;
export default paginatedMaterialsReducer

export const paginatedMaterialsSelectors = paginatedMaterials.LF.selectors